import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Edit",
  "use": "Edit-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"Edit\"><path d=\"M0 15.834V20h4.166L16.453 7.713l-4.166-4.166L0 15.834zM19.675 4.49a1.106 1.106 0 0 0 0-1.566l-2.6-2.6a1.106 1.106 0 0 0-1.566 0l-2.033 2.033 4.166 4.166 2.033-2.033z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol